<template>
    <split-pane  :min-percent='10' :default-percent='14' split="vertical" style="background:white; height:100%">
        <template slot="paneL">
            <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium"  ></el-input> 
            <el-tree :data="subData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        node-key="id"                       
                        :style="{height: scrollerHeight,overflow:'auto',display: 'flex',padding:15}"
                        highlight-current
                        :filter-node-method="filterNode"
                        v-loading="loadingtree"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"   
                        ref="eltree"
                        default-expand-all
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.id ==0 "  class="nodeRoot" >
                        <span style="font-size:14px; color:#409efe"><i class="iconfont   icon-kucunguanli" style="color:#409eff;font-size:16px;margin-right:3px;"></i>{{ node.label}} </span>
                    </span>                  
                    <span v-else > 
                        <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="color:#409eff;font-size:14px;margin-right:3px;"></i> {{ node.label}}-{{data.id}} </span>
                    </span>
                </template>
            </el-tree>
        </template>  
        <template slot="paneR">         
            <div class="headbar">
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                <el-link :disabled="addBool"  @click="addRec" :underline="false" ><span style="font-size:13px;margin-right:15px;">新增科目</span></el-link>
 
                <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px; ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" v-if="item.thide=='N'" :value="item.key" style="width:150px;"></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值" @keyup.enter.native="qryTabData" v-model="txtparam" size="small" style="width:380px; height:30px ">
                    <el-button slot="append" size="small" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                    <div slot="prepend">
                        <el-select v-model="oper"  size="small" style="width:110px;" >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </span>
                        </el-select>
                    </div>
                </el-input>  

            </div>
            <el-table  :data="tabData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :cell-style="{padding:'2px'}"
                    :height="tabHeight" 
                    :row-key="getRowKey"  
                    ref="tabref" 
                    @row-click="rowClick"
                    highlight-current-row>
                <el-table-column  v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.key!=='RN'&&item.edcss!=='checkbox'"
                    :min-width="item.width">
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" ></el-checkbox>
                        <span v-else v-text="scope.row[item.key]" ></span>
                    </template>
                </el-table-column> 
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="145">
                    <template slot-scope="scope">
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="editBool" @click="editRec(scope.row,'N')" :underline="false"  ><span style="font-size:11px;margin-right:15px;">编辑 </span></el-link>
                        <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="delBool" @click="delRec(scope.row )" :underline="false"  ><span style="font-size:11px;margin-right:10px;">删除 </span></el-link>
                    </template>
                </el-table-column>                      
            </el-table> 
            <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:10px;padding-left:5px">
                <div style="float: left;">
                    <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                </div>
                <div style="color:#606266;margin:7px 10px;font-size:12px;width:35px;">每页</div>
                <el-select v-model="rowSize" size="small" style="width:80px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266;margin:7px 10px;margin-left:80px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266;margin:7px 5px;font-size:12px;">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:50px;margin-left:15px;height:32px;">GO</el-button>
            </div> 
            <el-dialog v-dialogDrag :visible.sync="addModal" width="1000px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{type==='create'?'新增记录':'编辑记录'}}</span>
                </div> 
                <Form ref="addForm" :model="formCol" :label-width="120"  :rules="ruleValidate"  label-position="right" inline >
                    <span v-for="(item,index) in tabArr" :key="index" >
                        <FormItem :class="(item.key=='SUBNM'||item.key=='ENAME')?'item-width2':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                            <el-input :placeholder="item.holder" :disabled="saveFlag" v-enter-number  v-if="item.edcss==='number'" v-model="formCol[item.key]" style="width:100%" ></el-input>   
                            <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol[item.key]" style="width:100%"></el-checkbox> 
                            <el-input  type="textarea" :rows="3"  v-else-if="item.key==='SUBNM'"   v-model="formCol[item.key]"></el-input>
                            <el-select v-else-if="item.key==='FINACNO'" v-model="formCol[item.key]" clearable style="width:100%" filterable>
                                <el-option v-for="(it,index) in  bsArr " :key="index"  :value="it.IDNO" :label="it.CNAME" >
                                    <span style="float:left">{{it.CNAME}}</span>
                                    <span style="float:right;color:#ccc">{{it.IDNO}}</span>
                                </el-option>
                            </el-select> 
                            <el-input v-enter-number type="text" v-else-if="item.key=='IDNO'" v-model="formCol[item.key]"></el-input>
                            <el-input :placeholder="item.holder" type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag "  v-model="formCol[item.key]"></el-input>

                        </FormItem>
                    </span>
                </Form>   
 
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                    <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addModal=false" style="margin-right:50px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="modal_ok" style="margin-right:10px;">保存</el-button>
                    </span>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
                </div> 
                <span>{{prompt}}</span>
                <span slot="footer"  >
                    <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 上传进度 -->
            <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                    <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在导入中...</span>
                </div>
                <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
            </el-dialog>
        </template>     
    </split-pane> 
</template>

<script>
  import FileSaver from 'file-saver'
  import { getTabColOrData,getBaseData } from '../../api/user'
  export default {
    name: 'amz_subject',
 
    data() {
      return {
        bsArr:[],
 
        videoFlag:false,
        videoUploadPercent:0,
        promptWin:false,
        prompt:'',
        addModal:false, //modal 
        formCol:{}, //表格单行记录 model
        subData:[] , //树结构数据
        oper:'like',
        selparam:'CNAME',
        txtparam:'',
        loadingtree:false,
        filterText: '',
        operArr:[],
        defaultProps: {  //el-tree 默认字段属性
            children: 'children',
            id:'id',
            icon:'icon',
            parentid:'',
            label: 'label'
        },
        ruleValidate:{}, //校验规则
        type: 'create',
        nodeLabel:'亚马逊科目类别',
        treeid :'0',
        parentid:'',
        allData:[],
        tabData:[],
        tabArr:[],
        saveFlag:false,
        v_url:'xuper_auth/getTableRecMany' , //api请求路径
        addBool:false, //新增,为true时--禁止
        editBool:false, //编辑,为true时--禁止
        delBool:false, //删除 ,为true时--禁止
        cfmBool:false, //审核 ,为true时--禁止
        cancelBool:false, //作废 ,为true时--禁止 
        v_admin:this.$cookies.get('v_admin') ,//      
        v_username:this.$cookies.get('v_telno'), //api 请求用户
        
        v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
        dataCount:0,
        rowSize:50,
        goPage:'',
        current:1,
        stfgBool:true,
        notNull:[],
        pageList: [ {
            value: 50,
            label: '50'
            }, {
            value: 100,
            label: '100'
            }, {
            value: 200,
            label: '200'
        }],
      }
    },
    watch: {
        filterText(val) {
            this.$refs.eltree.filter(val);
        }
    },
    created () {
        if(this.v_username){
            this.getData() //左边树
            this.getTabField() // 字段集
            this.getAccList(' and parentno=\''+this.treeid+'\'')  
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });
        getBaseData(this.v_url,'','','','','V_AC_SUBJECT','').then(res=>{
            this.bsArr =res.result
        });
 
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','120382','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 128) + 'px';
            },
            tabHeight: function() {
                return (window.innerHeight - 160) + 'px';
            }, 
        },
    methods: {
 
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
            this.getAccList(' and parentno=\''+this.treeid+'\' '+cond_)
        },
        getRowKey(row){
            return row.IDSEQ
        },
        rowClick(row){

        },
        editRec(row,val){
 
            this.formCol =JSON.parse(JSON.stringify(row))
            this.addModal=true 
             
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt='请输入跳至页数'
            }
        },
        //科目明细
        getAccList(cond){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'V_AMZ_SUBJECT'},
            }).then(res=>{ 
                this.allData=[]
                if (res.code==='200'){
                    for(let k=0;k<res.result.length; k++){
                        let row_=res.result[k]
                        let bschk_='' ,obj_={},costchk_='',abc_=''
                        if (row_.BSCHK){
                            bschk_ =row_.BSCHK.split(',')
                        }
                        if (row_.COSTCHK){
                            costchk_ =row_.COSTCHK.split(',')
                        }
                        if (row_.ABC){
                            abc_ =row_.ABC.split(',')
                        }
                        Object.assign(obj_,row_,{'BSCHK':bschk_ ,'COSTCHK':costchk_,'ABC':abc_})
                        this.allData.push(obj_)
                    }
                    this.initPage() 
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.tabref.doLayout();
                })
            }) 
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.tabData = this.allData.slice(_start,_end);
        },
        //确定 保存
        modal_ok(){
            //发起保存请求   
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.formCol[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) { 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.formCol,{ CORPID:this.v_corpid } ) ), p_table:'AMZ_SUBJECT',p_frmid:''},
                }).then(res=>{   
                    //console.log('form:'+JSON.stringify(this.formCol))      
                    if(res.code ==='200')  {     
                        this.addModal =false   
                        this.getAccList(' and parentno=\''+this.treeid+'\'') 
                        this.getData()      
                    }else{
                        if (res.result.indexOf('ORA-00001')>-1){
                            this.prompt ='科目编码重复，请核查'
                        }else{
                            this.prompt=res.result
                        }
                        this.promptWin=true
                    }        
                }) 
            } 
        } ,
        //新增
        addRec(){  
            this.addModal =true
            this.type ='create'
            this.formCol ={IDSEQ:'',IDNO:'',PARENTNO:this.treeid,PCNAME:this.nodeLabel,STFG:'N'}              
        },
 
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        //节点点击
        handleNodeClick(data){
            this.nodeLabel=data.label;            
            this.treeid =data.id
            this.parentid=data.parentid
            this.getAccList(' and parentno=\''+data.id+'\'')
        },
        //删除记录
        delRec(row){
            this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                //发起删除请求
                var vm=this;
                //选判断有没子节点
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'parentno',p_value:row.IDNO,p_key2:'corpid',p_value2:this.v_corpid,p_table:'v_AMZ_subject'},
                }).then(res=>{  
                    if (res.result.length===0){
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'aMZ_subject'},
                        }).then(res=>{      
                            if(res.code =='200')  {           
                                vm.getData()   
                                vm.getAccList(' and parentno=\''+this.treeid+'\'')     
                            }else{
                                this.promptWin=true
                                this.prompt=res.result
                            }        
                        }) 
                    }else{
                        this.promptWin=true
                        this.prompt='存在子记录,不能删除'
                    }
                })      
            }).catch(()=>{})
       
        },
        // 获取 树形控件数据
        getData() {   
            var vm=this;
            this.loadingtree=true
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'V_AMZ_MENU',p_cond:' and ( corpid=\''+this.v_corpid+'\') ORDER BY code'}
            }).then(function(res){ 
                if (res.code==='200'){                 
                    vm.subData =res.result;  
                    vm.$nextTick(()=>{ //必须要放在nexttick里，要不然还未渲染上
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                } else{
                    vm.promptWin=true
                    vm.prompt=res.result
                }  
                vm.loadingtree=false          
            })                            
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','120382','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        }
    }
  }
</script>
<style scoped>
 .siderCls{
     background:#fff;
     margin: 3px auto;
     width: 260px;
     min-width: 260px;
     max-width:260px;
     border-right: 2px solid #C0C4CC;
}
    .item-width  {
        width: 48%;
    } 
    .item-width2  {
        width: 97%;
    } 
.headbar{
    padding-left:2px; 
    line-height:30px;
    background:#fff;
    overflow: auto;
    padding-top:3px;
    display:flex;
    border-bottom:2px solid #389;
    height:40px;
}
.treeCss{
    padding-left:5px; 
    width:100%;
    background:#fff;
    margin:2px auto ;
    margin-top:5px;
   overflow:auto;
   height: calc(100vh - 130px);
}
.nodeLabel{
        font-size:12px;
        font-weight:500;
        padding-left:10px;
        color: black;
    }
.nodeRoot{
        width:20px;
        font-size:14px;
        font-weight:600;
    }  
.top{
        padding: 10px;
        background: rgba(0, 153, 229, .7);
        color: #fff;
        text-align: center;
        border-radius: 2px;
    }        
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{  //用于表格中checkbox disabled时为蓝色
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
